import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  ListGroup,
  Image,
  Button,
  Card,
  Table,
} from "react-bootstrap";
import Message from "../components/Message";
import { addToCart, removeFromCart } from "../actions/cartActions";

function CartScreen({ match, location, history }) {
  const productId = match.params.id;
  const qty = location.search ? Number(location.search.split("=")[1]) : 1;
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  useEffect(() => {
    if (productId) {

      dispatch(addToCart(productId, qty));
    }
  }, [dispatch, productId, qty]);

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id));
  };

  // Tractor total
  let tractorsTotalPrice = 0;
  cartItems.forEach((item) => {
   if (item.tractors && item.tractors.length > 0) {
      tractorsTotalPrice += item.tractors.reduce(
        (acc, tractor) => acc + tractor.price * qty,
        0
      );
    }
  });
  

  // attachement total
  let attachmentsTotalPrice = 0;
  cartItems.forEach((item) => {
    if (item.attachments) {
      attachmentsTotalPrice += item.attachments.reduce(
        (acc, attachment) => acc + attachment.price * qty,
        0
      );
    }
  });

  // options total
  let optionsTotalPrice = 0;
  cartItems.forEach((item) => {
    if (item.options) {
      optionsTotalPrice += item.options.reduce(
        (acc, option) => acc + option.price * qty,
        0
      );
    }
  });

  const checkoutHandler = () => {
    if (userInfo) {
      history.push("/adjustments");
    } else {
      history.push("/guest");
    }
  };


  return (
    <Row>
      <Col md={8}>
        <h2>Quote Tray</h2>
        {userInfo && cartItems.length > 0}
        <hr></hr>
        {cartItems.length === 0 ? (
          <Message variant={"primary"}>
            <p
              style={{
                fontSize: "2rem",
                textAlign: "center",
                padding: "50px",
              }}
            >
              Your tray is empty{" "}
            </p>{" "}
            <Link
              to="/"
              className="buttonBack position-absolute bottom-0 start-50 translate-middle-x"
            >
              Go Back
            </Link>
          </Message>
        ) : (
          <ListGroup variant="flush">
            {cartItems.map((item) => (
              <ListGroup.Item key={item.product}>
                <Row>
                  <Col md={2}>
                    <Image
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      src={item.image}
                      alt={item.name}
                      fluid
                      rounded
                    />
                  </Col>
                  <Col md={7}>
                    <Link
                      className="productLink"
                      to={`/product/${item.product}`}
                    >
                      {item.name} - {item.short_description}
                    </Link>
                  </Col>
                  {/* Tractor Price */}
                  <Col md={3} className="mb-4">
                    {userInfo ? (
                      <Col className="cartPrice">
                        $
                        {parseFloat(cartItems.reduce((acc, item) => acc + item.qty, 0) * item.tractors.reduce(
                          (acc, tractor) => acc + tractor.price,
                          0
                        )).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        <span className="attCartDescription"> DealerNet</span>
                        <br></br>$
                        {parseFloat(cartItems.reduce((acc, item) => acc + item.qty, 0) * item.tractors.reduce(
                          (acc, tractor) => acc + tractor.MSRP,
                          0
                        )).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        
                        <span className="attCartDescription "> MSRP</span>
                      </Col>
                    ) : (
                      <Col md={2}></Col>
                    )}
                  </Col>
                 
                  {/* ATTACHMENTS SQUARE */}
                  <Row md={2} className="cartRow">
                    <ListGroup>
                      <ListGroup.Item className="rounded">
                        {item.attachments && item.attachments.length > 0 ? (
                          <Table class="table table-hover">
                            <span className="attCartDescription">
                              Attachments:
                            </span>
                            <tbody>
                              {item.attachments.map((attachment) => (
                                <tr>
                                  <td className="attCartTitle">
                                    {attachment.name}
                                  </td>
                                  {userInfo && (
                                    <td className="attCartPrice">
                                      $
                                      {(attachment.price * qty).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )}
                                      <span className="attCartDescription">
                                        {" "}
                                        DealerNet
                                      </span>
                                      <br></br>$
                                      {(attachment.MSRP * qty).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )}
                                      <span className="attCartDescription">
                                        {" "}
                                        MSRP
                                      </span>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        ) : (
                          <p>No attachments added</p>
                        )}
                      </ListGroup.Item>
                    </ListGroup>
                    {/* OPTIONS SQUARE */}
                    <ListGroup>
                      <ListGroup.Item className="rounded">
                        {item.options && item.options.length > 0 ? (
                          <Table class="table table-hover">
                            <span className="attCartDescription">Options:</span>
                            <tbody>
                              {item.options.map((option) => (
                                <tr>
                                  <td className="attCartTitle">
                                    {option.name}
                                  </td>
                                  {userInfo && (
                                    <td className="attCartPrice" style={{}}>
                                      $
                                      {(option.price * qty).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )}
                                      <span className="attCartDescription">
                                        {" "}
                                        DealerNet
                                      </span>
                                      <br></br>$
                                      {(option.MSRP * qty).toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )}
                                      <span className="attCartDescription">
                                        {" "}
                                        MSRP
                                      </span>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        ) : (
                          <p>No options added</p>
                        )}
                      </ListGroup.Item>
                    </ListGroup>
                     {/* Delete Button */}
                  <ListGroup className="offset-md-6 mt-4">
                      <ListGroup.Item className="border-0"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                      >
                        <Button
                          className="buttonDelete"
                          type="button"
                          onClick={() => removeFromCartHandler(item.product)}
                        >
                          Remove
                        </Button>
                      </ListGroup.Item>
                    </ListGroup>
                  </Row>
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Col>
      <Col md={4} className="order-md-2 mb-4">
        <Card
          style={{
            boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          {/* SUMMARY */}
          <ListGroup variant="flush">
            <ListGroup.Item>
              {userInfo ? (
                <h4 className="summaryTitle">Summary</h4>
              ) : (
                <h4>
                  There is {cartItems.reduce((acc, item) => acc + item.qty, 0)}{" "}
                  items in your quote.
                </h4>
              )}
              {userInfo ? (
                <ListGroup.Item
                  style={{
                    borderRadius: "10px 10px 0px 0px",
                  }}
                >
                  <Row>
                    <Col>
                      {cartItems && cartItems.length > 1
                        ? "Tractors:"
                        : "Tractor:"}
                    </Col>
                    <Col>
                      <span className="price style1">
                        $
                        {tractorsTotalPrice.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </Col>
                  </Row>
                </ListGroup.Item>
              ) : (
                <span></span>
              )}
              {userInfo ? (
                <ListGroup.Item>
                  <Row>
                    <Col>Attachments:</Col>
                    <Col>
                      <span className="price style1">
                        $
                        {attachmentsTotalPrice.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </Col>
                  </Row>
                </ListGroup.Item>
              ) : (
                <span></span>
              )}
              {userInfo ? (
                <ListGroup.Item>
                  <Row>
                    <Col>Options:</Col>
                    <Col>
                      <span className="price style1">
                        $
                        {optionsTotalPrice.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </Col>
                  </Row>
                </ListGroup.Item>
              ) : (
                <span></span>
              )}
              {userInfo ? (
                <ListGroup.Item
                  style={{
                    borderRadius: "0px 0px 10px 10px",
                  }}
                >
                  <Row>
                    <Col>
                      Dealer Net:
                    </Col>
                    <Col>
                      <span className="price style2">
                        $
                        {(
                          tractorsTotalPrice +
                          attachmentsTotalPrice +
                          optionsTotalPrice
                        ).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </Col>
                  </Row>
                </ListGroup.Item>
              ) : (
                <span></span>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Card>
        <h4>
          {userInfo && cartItems.length > 1 && <p>Only one item per quote</p>}

          <Button
            type="button"
            className="button std2"
            disabled={
              cartItems.length === 0 || (userInfo && cartItems.length > 1)
            }
            onClick={checkoutHandler}
          >
            {userInfo ? (
              <span>Proceed with Quote</span>
            ) : (
              <span>Get Custom Quote</span>
            )}
          </Button>
        </h4>
      </Col>
    </Row>
  );
}
export default CartScreen;
